// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";
import translationHI from "./locales/hi/translation.json";
import translationMR from "./locales/mr/translation.json";
import translationVI from "./locales/vi/translation.json";
import translationPT from "./locales/pt/translation.json";
import translationFR from "./locales/fr/translation.json";

const resources = {
    en: { translation: translationEN },
    es: { translation: translationES },
    hi: { translation: translationHI },
    mr: { translation: translationMR },
    vi: { translation: translationVI },
    pt: { translation: translationPT },
    fr: { translation: translationFR },
};
const language = sessionStorage.getItem('language') || "en";

i18n
    //.use(LanguageDetector) // auto-detect browser language
    .use(initReactI18next)
    .init({
        resources,
        lng: language,
        fallbackLng: "en", // default language

        interpolation: {
            escapeValue: false, // react already escapes
        },
    });

export default i18n;
